import CovaloMediaButton from '../SocialMedia/CovaloMediaButton';
import ToolTipContent from '../ToolTipContent';
import { FC, useContext } from 'react';
import { copyToClip, getMediaURL } from './helper';
import { tss } from 'tss-react/mui';
import { UserContext } from 'context/User';
import Close from '@mui/icons-material/Close';
import { useAnchorElement } from 'hooks/useAnchorElement';
import { Box, Popover } from '@mui/material';

interface Props {
  name: string;
  from: 'company' | 'product';
  children: JSX.Element;
}
export const ShareButton: FC<Props> = ({ name, children, from }) => {
  const { classes } = useStyles();
  const URL = window.location.href;
  const user = useContext(UserContext);
  const userName = (user?.firstName ?? ' ') + (user?.lastName ?? '');
  const medias = ['email', 'linkedin', 'whatsapp', 'twitter'];
  const { anchor, handleOpenMenu, handleMenuClose } = useAnchorElement();

  return (
    <>
      <Box onClick={handleOpenMenu}>{children}</Box>
      <Box
        component={Popover}
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={handleMenuClose}
        classes={{ paper: classes.root }}
        slotProps={{
          paper: {
            elevation: 2,
            square: false
          }
        }}
      >
        <div className={classes.header}>
          <div>Share this {from} page</div>
          <Close fontSize="small" onClick={handleMenuClose} />
        </div>
        <div className={classes.container}>
          {medias.map(media => (
            <ToolTipContent tooltip text={`Share on ${media}`} key={media}>
              <CovaloMediaButton
                media={{
                  url: getMediaURL(media, URL, name, userName),
                  type: media
                }}
              />
            </ToolTipContent>
          ))}
        </div>
        <div className={classes.copyContainer}>
          <div className={classes.url}>
            <div>{URL}</div>
          </div>
          <ToolTipContent tooltip text="Copy Link">
            <CovaloMediaButton
              media={{ url: '', type: 'link' }}
              customFunction={() => copyToClip(URL)}
            />
          </ToolTipContent>
        </div>
      </Box>
    </>
  );
};

const useStyles = tss.create(({ theme }) => ({
  root: {
    position: 'absolute',
    padding: 10
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    color: theme.palette.text.primary,
    fontSize: 14,
    textAlign: 'center',
    fontWeight: 400
  },
  container: {
    display: 'flex'
  },
  copyContainer: {
    display: 'flex',
    alignItems: 'stretch',
    marginTop: 10
  },
  url: {
    border: `1px solid ${theme.palette.grey[400]}`,
    width: 300,
    marginRight: 4,
    display: 'flex',
    alignItems: 'center',
    div: {
      fontSize: 14,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      width: 300,
      whiteSpace: 'nowrap',
      padding: '0 4px'
    }
  }
}));
